import dayjs from '../utils/dayjs.js'
export function convertDate (timeStamp){
    return dayjs(timeStamp).format('DD-MM-YYYY');
}

export function convertDateToYY (timeStamp){
    return dayjs(timeStamp).format('YYYY-MM-DD');
}


export function convertDateFormat(date){
    return dayjs(date).format('DD-MM-YYYY');
}
